export default __webpack_public_path__ + "static/media/640_store01-en-mobile.8c5960d9.png";